module.exports = __webpack_public_path__ + "static/usopen-01-5a11b2c779d0dde467ca758fba70fc2f.jpg";